import { inputClassNames } from "components/forms/input";
import { useBasket } from "lib/hooks/basket/use-basket";
import { useInput, ValidationResult } from "lib/hooks/use-input";
import { IVerifyDiscount } from "pages/api/validate-discount";
import { ValidDiscount } from "./valid-discount";

export const DiscountSection = () => {
  const [basket, modifyBasket] = useBasket();

  const discount = useInput<string>(
    "",
    async (rawValue): Promise<ValidationResult> => {
      const value = rawValue.trim();
      if (!value) {
        return { valid: false, message: "Please enter a discount code" };
      }
      if (value.length < 8) {
        return {
          valid: false,
          message: "Discount codes must be at least 8 characters long",
        };
      }
      try {
        const res = (await (
          await fetch(`/api/validate-discount`, {
            method: "POST",
            body: JSON.stringify({
              code: value,
            } as IVerifyDiscount),
          })
        ).json()) as ValidationResult;

        if (res.valid) {
          modifyBasket({
            type: "add-discount",
            payload: res.data,
          });
          return res;
        } else {
          return {
            valid: false,
            message: res.message || "Discount code is not valid",
            data: res.data,
          };
        }
      } catch (err) {
        return {
          valid: false,
          message:
            "There was an error validating your discount code - please contact us if this persists",
        };
      }
    }
  );

  if (basket.items.length > 0) {
    return (
      <>
        <li className='pb-4 pt-4 flex flex-row flex-wrap '>
          <h2
            id='discountLabel'
            className='inline-flex font-bold text-sm flex-shrink mr-4'>
            <svg
              className='h-5 w-5 my-auto mr-2'
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth={2}
                d='M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z'
              />
            </svg>
            <span className='my-auto'>Discount</span>
          </h2>
          {!basket.discount ? (
            <>
              <div
                className={`${inputClassNames} ${
                  discount.isModified && !discount.isValid
                    ? "ring-1 ring-red-default focus-within:border-red-default"
                    : "ring-green-default focus-within:border-green-default"
                } focus-within:ring-1  flex flex-row flex-1 `}>
                <input
                  className='border-none focus:ring-0 flex-grow'
                  type='text'
                  name='discount'
                  id='discount'
                  placeholder='enter discount code'
                  aria-labelledby='discountLabel'
                  {...discount.bind}
                />
                <button
                  className='ml-auto flex-shrink hover:bg-yellow-default px-2 rounded'
                  type='button'
                  onClick={() => discount.validate()}>
                  {discount.isValidating ? "Validating" : "Validate"}
                </button>
              </div>
              {discount.isModified && discount.validation?.message && (
                <>
                  {discount.validation.data?.length > 0 ? (
                    <div
                      className={`w-full mt-4 text-sm px-2 py-4 text-center ${
                        !discount.validation.valid
                          ? "border border-yellow-default bg-orange-50 rounded"
                          : ""
                      }`}>
                      <p>{discount.validation.message}</p>
                    </div>
                  ) : (
                    <p
                      className={`w-full mt-4 text-sm px-2 py-4 text-center ${
                        !discount.validation.valid
                          ? "bg-red-100 rounded   "
                          : ""
                      }`}>
                      {discount.validation.message}
                    </p>
                  )}
                </>
              )}
            </>
          ) : (
            <ValidDiscount />
          )}
        </li>
      </>
    );
  } else {
    return null;
  }
};
